import { Injectable } from '@angular/core';

@Injectable()
export class ValidationService {
    constructor(
    ) {

    }

    emailIsValid(email: string): boolean {
        let isValid = false;
        const regexp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (email && email.trim().length > 0) {
            if (regexp.test(email)) {
                isValid = true;
            }
        }

        return isValid;
    }
}



// WEBPACK FOOTER //
// ./src/services/helpers/validation.service.ts